import { render, staticRenderFns } from "./AdminCampaignsForm.vue?vue&type=template&id=17885d70&"
import script from "./AdminCampaignsForm.vue?vue&type=script&lang=js&"
export * from "./AdminCampaignsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports